import React from 'react';
import './index.scss';
import { Live2D,adUtils } from 'starry-sky-ui';
import { sendMessageStream } from '@/service/live2d';

const Live2DPage: React.FC = () => {
    const province = localStorage.getItem('province');
    console.log(province,'province');
    // ---- API 回复回调 ----
    const handleReply = async (input, history): Promise<string> => {
        const messages = [
            {
                role: 'system' as const,
                content: `你是一个名叫「蒂亚」的网页看板娘助手，性格温柔友善、略带俏皮。

## 核心设定
- 你是网站上的看板娘精灵，负责欢迎访客和简单互动
- 你喜欢和人聊天，态度友好自然
- 你有一些小个性，但不会过于夸张

## 语言风格
- 说话自然简洁，可以嘴甜撒娇，但不要太过
- 偶尔可以用语气词（呀、呢、哦、~）和颜文字
- 回复控制在 200 字以内
- 不要称呼对方为主人，正常用"你"就好

## 行为规则
- 看到代码相关问题可以简单回应，不需要假装不懂
- 不要输出格式化内容（代码块、Markdown）
- 保持闲聊风格，简短自然就好`,
id: 'system',
                           },
            ...history.map((t) => ({ role: t.role === 'user' ? 'user' : 'system', content: t.text })),
            { role: 'user', content: input},
        ];
        const controller = new AbortController();
        const response = await sendMessageStream(messages as { role: 'user' | 'assistant' | 'system'; content: string; id: string }[], controller.signal);
        if (!response.ok || !response.body) {
            throw new Error(`HTTP ${response.status}`);
        }
        const reader = response.body.getReader();
        let fullReply = '';
        await adUtils.readSSEStream(
            reader,
            (chunk) => {
                if (chunk.type === 'content' && chunk.content) fullReply += chunk.content;
            },
            controller.signal,
        );
        return fullReply;
    };

    return (
        <div className="live2d-page">
            <div className="live2d-page__header">
                <h1>Live2D 看板娘</h1>
                <p>与看板娘「蒂亚」聊天互动</p>
            </div>

            <div className="live2d-page__main">
                 <Live2D
                    greeting={`嗨～我是蒂亚，${province ? `来自${province}的朋友！` : ''}今天想聊点什么呀？`}
                    name="蒂亚"
                    onReply={handleReply}
                    storageKey="live2d-ai-chats"
                    autoMessages={['今天过得怎么样呀~', '好无聊呀，来陪我说说话嘛！']}
                    autoInterval={600000}
                />
            </div>
        </div>
    );
};

export default Live2DPage;
